import axios from 'axios';
import { headers, getBackOfficeRoute } from './header';
import { ROLE_ADMIN, ROLE_RENTER } from '../../constants/roles';

const BikesApiService = {

  getBikes(token, role) {
    return axios
      .get(`${getBackOfficeRoute(role)}/bikes`, {
        headers: headers(token),
      })
      .then((response) => response.data);
  },

  postAdminBikes(token, data) {
    return axios
      .post(`${getBackOfficeRoute(ROLE_ADMIN)}/bikes`, data, {
        headers: headers(token),
      })
      .then((response) => response.data);
  },

  putRenterBike(token, bikeID, data) {
    return axios
      .put(`${getBackOfficeRoute(ROLE_RENTER)}/bikes/${bikeID}`, data, {
        headers: headers(token),
      })
      .then((response) => response.data);
  },
};

export default BikesApiService;



// WEBPACK FOOTER //
// ./src/services/api/BikesApiService.js